import { useEffect, useState } from "react";
import { ListMusic, Loader2, PlayCircle, Square } from "lucide-react";
import { bulletin, wholeStory } from "@/lib/storyRead";

// The two ways to hear a box of stories: one at a time, or the lot as a bulletin.
export const BoxPlayers = ({ rows, speaker, lang, name }) => {
  const spot = `cml_playat_${name}`;
  const [at, setAt] = useState(() => Number(localStorage.getItem(spot)) || 0);
  const top = rows[0]?.story_id || "";

  // your place is kept, unless these are different stories to the ones you were on
  useEffect(() => {
    if (localStorage.getItem(`${spot}_top`) !== top) {
      localStorage.setItem(`${spot}_top`, top);
      setAt(0);
    }
  }, [spot, top]);

  useEffect(() => {
    localStorage.setItem(spot, String(at >= rows.length ? 0 : at));
  }, [at, rows.length, spot]);

  if (!rows.length) return null;

  const busy = rows.some((row) => speaker.playing === `${row.story_id}-read`);
  const loading = rows.some((row) => speaker.loading === `${row.story_id}-read`);

  const playOne = () => {
    const story = rows[Math.min(at, rows.length - 1)];
    speaker.play(`${story.story_id}-read`, wholeStory(story, lang), story.title);
    setAt((i) => (i + 1 >= rows.length ? 0 : i + 1));
  };

  return (
    <span className="ms-auto inline-flex shrink-0 items-center gap-2">
      <button
        data-testid={`${name}-play-one`}
        onClick={busy ? speaker.stop : playOne}
        className="inline-flex min-h-[30px] items-center gap-1.5 rounded-full border border-brand/50 px-3 text-[11px] font-semibold text-brand transition-colors hover:bg-brand/10 active:scale-95"
      >
        {busy ? <Square className="h-3 w-3" /> : <PlayCircle className="h-3 w-3" />}
        {busy ? "Stop"
          : at === 0 || at >= rows.length ? "Play each one"
          : `Play the next one (${at + 1} of ${rows.length})`}
      </button>
      <button
        data-testid={`${name}-play-all`}
        onClick={busy ? speaker.stop : () => { setAt(0); speaker.playQueue(bulletin(rows, lang)); }}
        className="inline-flex min-h-[30px] items-center gap-1.5 rounded-full bg-brand px-3 text-[11px] font-semibold text-white transition-colors hover:bg-brand-hover active:scale-95"
      >
        {loading ? <Loader2 className="h-3 w-3 animate-spin" /> : <ListMusic className="h-3 w-3" />}
        Play them all
      </button>
    </span>
  );
};
